import supportsWebP from "supports-webp";
import { OFFER_LATER, ON_OFFER } from "../../types/offerStates";
export const getMarker = (offerStatus: OfferStatus) => {
    switch (offerStatus) {
        case ON_OFFER:
            return supportsWebP
                ? {
                        url: require("../../images/green.webp"),
                  }
                : {
                        url: require("../../images/green.png"),
                  };
        case OFFER_LATER:
            return supportsWebP
                ? {
                        url: require("../../images/orange.webp"),
                  }
                : {
                        url: require("../../images/orange.png"),
                  };
        default:
            return undefined;
    }
};
